"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
let IS_READY;

class PromoClip {
  constructor() {
    // this values used in the tween for update alpha or tine
    this.a = 1; // alpha in tween values

    this.t = 0; // time in tween values

    this.tweens = [];
  }

  set isReady(promise) {
    IS_READY = promise;
  }

  get isReady() {
    return IS_READY;
  }

  get guid() {
    return this.clip.guid;
  }

  get start() {
    const {
      timeline: {
        start: {
          timestamp
        }
      }
    } = this.clip;
    return timestamp;
  }

  get end() {
    const {
      timeline: {
        end: {
          timestamp
        }
      }
    } = this.clip;
    return timestamp;
  }

  get offset() {
    const {
      timeline: {
        offset
      }
    } = this.clip;
    return offset;
  }

  get duration() {
    const {
      timeline: {
        start,
        end
      }
    } = this.clip;
    return end.timestamp - start.timestamp;
  }

  get inType() {
    const {
      timeline: {
        start: {
          transition
        }
      }
    } = this.clip;
    return transition;
  }

  get inDuration() {
    const {
      timeline: {
        start: {
          transitionDuration
        }
      }
    } = this.clip;
    return transitionDuration;
  }

  get outType() {
    const {
      timeline: {
        end: {
          transition
        }
      }
    } = this.clip;
    return transition;
  }

  get outDuration() {
    const {
      timeline: {
        end: {
          transitionDuration
        }
      }
    } = this.clip;
    return transitionDuration;
  }

  get inTransition() {
    return {
      start: this.start,
      offset: this.offset,
      duration: this.inDuration,
      transition: this.inType
    };
  }

  get idle() {
    const inDuration = this.inDuration;
    return {
      start: this.start + inDuration,
      offset: this.offset + inDuration,
      duration: this.duration - inDuration - this.outDuration
    };
  }

  get outTransition() {
    const outDuration = this.outDuration;
    return {
      start: this.end - outDuration,
      offset: this.offset + this.duration - outDuration,
      duration: outDuration,
      transition: this.outType
    };
  }

  get filter() {
    const {
      filter
    } = this.clip;

    if (filter && filter.type === 'color') {
      return filter.color;
    }

    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0
    };
  }

  destroy() {
    return () => {
      // need to clean what we can
      // kill tweens
      this.tweens.forEach(tween => {
        tween.kill();
      }); // remove all keys

      Object.keys(this).forEach(key => {
        delete this[key];
      });
    };
  }

}

exports.default = PromoClip;